export const RESULTS_PER_PAGE_JOURNAL = 10;
export const CROSSREF_API_URL = 'https://api.crossref.org/works';
export const CROSSREF_API_TOKEN = process.env.CROSSREF_API_TOKEN;
